var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileSelectedSolid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2995 4.44099L10.9768 2.11699C10.5444 1.68241 10.0301 1.33787 9.46365 1.10329C8.89722 0.868712 8.28991 0.748743 7.67683 0.750321H4.66683C3.7831 0.751379 2.93587 1.10291 2.31098 1.7278C1.68608 2.35269 1.33455 3.19992 1.3335 4.08365V13.417C1.33455 14.3007 1.68608 15.1479 2.31098 15.7728C2.93587 16.3977 3.7831 16.7493 4.66683 16.7503H11.3335C12.2172 16.7493 13.0645 16.3977 13.6894 15.7728C14.3142 15.1479 14.6658 14.3007 14.6668 13.417V7.74032C14.6685 7.12727 14.5485 6.51998 14.3138 5.95364C14.0791 5.38729 13.7343 4.87315 13.2995 4.44099Z",
    fill: "#DB5327"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64582 10.1153L6.54235 12.0118L11.3587 7.19998L12 7.84125L6.54235 13.2989L4 10.7565L4.64582 10.1153Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileSelectedSolid);
export default __webpack_public_path__ + "static/media/fileSelectedSolid.5d1d58d757e9b1afba51c8b37fdd409b.svg";
export { ForwardRef as ReactComponent };